import { FC, useEffect, useState } from 'react'

import { TableDataQa } from 'commons/types/enums'
import { Layer, Table } from 'ui/components'
import { Button } from 'ui/components/Buttons'
import { PageSectionPrimary } from 'ui/components/Page'

import { handlerServerError } from '@orbit/errors'

import { ManageAffiliatedCompany } from '../ManageAffiliatedCompany/ManageAffiliatedCompany'
import { AffiliatedCompaniesTableProps } from './AffiliatedCompaniesTableProps'
import { MappedAffiliatedCompany } from './MappedAffiliatedCompany'
import { columns } from './columns'
import { useComponentEssence } from './hooks'
import { useFilterCompanyAffiliatedCompaniesWebPage } from './hooks/useFilterCompanyAffiliatedCompaniesWebPage'

export const AffiliatedCompaniesTable: FC<AffiliatedCompaniesTableProps> = (props) => {
  const {
    data: { companyName, affiliatedCompanies, affiliatedCompaniesTotalCount, id }
  } = props
  const [webPageData, setWebPageData] = useState({
    affiliatedCompanies: affiliatedCompanies,
    affiliatedCompaniesTotalCount: affiliatedCompaniesTotalCount
  })

  useEffect(() => {
    setWebPageData({
      affiliatedCompanies: affiliatedCompanies,
      affiliatedCompaniesTotalCount: affiliatedCompaniesTotalCount
    })
  }, [affiliatedCompanies, affiliatedCompaniesTotalCount])

  const { routine: filterCompanyAffiliatedCompaniesWebPage } = useFilterCompanyAffiliatedCompaniesWebPage({
    onSuccess: async (_, result) => {
      await setWebPageData(result)
    },
    onError: (error) => handlerServerError(error)
  })

  const {
    tableFilter,
    loading,
    changePagination,
    DeleteConfirmation,
    openDeleteConfirmation,
    manageData: { relation, closeManageDialog, onSubmit, isLoading, openAddDialog, openEditDialog }
  } = useComponentEssence(
    id,
    companyName,
    filterCompanyAffiliatedCompaniesWebPage,
    webPageData.affiliatedCompaniesTotalCount
  )

  return (
    <>
      <ManageAffiliatedCompany
        initialValue={relation}
        onClose={closeManageDialog}
        onSubmit={onSubmit}
        isSubmitting={isLoading}
      />
      <DeleteConfirmation />
      <PageSectionPrimary
        title="Affiliated Companies"
        anchor="affiliated"
        actions={
          <Button face="tertiary" onClick={openAddDialog}>
            Add New
          </Button>
        }
        face="outlined"
      >
        <Layer rounded shadowed stretch>
          <Table<MappedAffiliatedCompany>
            dataQa={TableDataQa.BP_COMPANY_AFFILIATED_COMPANIES}
            dataSource={webPageData.affiliatedCompanies.map((el) => ({
              item: {
                id: el.id,
                mainCompanyId: id,
                mainCompanyName: companyName,
                affiliatedCompanyId: el.affiliatedCompanyId,
                affiliatedCompanyName: el.affiliatedCompanyName,
                notes: el.notes
              }
            }))}
            columns={columns(openEditDialog, openDeleteConfirmation)}
            loading={loading}
            pagination={{
              page: tableFilter.page,
              size: tableFilter.size,
              onChange: changePagination,
              total: webPageData.affiliatedCompaniesTotalCount
            }}
          />
        </Layer>
      </PageSectionPrimary>
    </>
  )
}
